// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"248":"cae98278afea0fb3","299":"247c1c6f5513f668","749":"6ee1afba0c706e0a","949":"6e749e2cbbd113db"}[chunkId] + ".js";
};